import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
  ThreeDots,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useVeiculoTransferencia, { LOAD_MESSAGE } from './VeiculoTransferenciaHook'
import VeiculoTransferenciaModal from './VeiculoTransferenciaModal/VeiculoTransferenciaModal'

function VeiculoTransferencia({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useVeiculoTransferencia()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.INITIAL_FETCH:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getVehiclesTransfer(selectedTp)
        break

      case LOAD_MESSAGE.DELETE_VEHICLE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.deleteVehicleTransfer(state.selectedVehicle.id, selectedTp)
        break

      case LOAD_MESSAGE.SUCCESS_DELETE:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <div>
      <PageHeader>2.10 - Veiculo Transferência</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.onBtnNovo(selectedTp)}
          onVoltar={() => history.goBack()}
        >
          <DataTable
            value={state.vehicles}
            paginator={true}
            rows={10}
            header={<CustomDataTableHeader onChange={localDispatch.onInputFilter} />}
            globalFilter={state.globalFilter}
            emptyMessage={'Sem veículos cadastrados'}
            style={state.vehicles.length === 0 ? { textAlign: 'center' } : {}}
          >
            <Column field="id" header="Código" style={tableCellCentered(80)} />
            <Column field="vehicle_badge" header="Placa" />
            <Column field="category" header="Categoria" />
            <Column
              field="actived"
              header="Ativo"
              style={tableCellCentered(80)}
              body={vehicle => <CustomCheckbox checked={vehicle.actived} />}
            />
            <Column
              header="Menu"
              style={tableCellCentered(70)}
              body={vehicle => (
                <ThreeDots
                  items={['Editar', 'Apagar']}
                  onClick={item => localDispatch.onMenuItemClicked(item, vehicle)}
                />
              )}
              bodyStyle={tableCellCentered()}
            />
          </DataTable>
        </CustomPanel>
      </div>
      <VeiculoTransferenciaModal
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
        vehicleTransfer={state.selectedVehicle}
        visible={state.showModal}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(VeiculoTransferencia))
